import Container from './Container';
import CreateForm from './CreateForm';
import SendingDomainsTab from './SendingDomainsTab';
import TrackingDomainsTab from './TrackingDomainsTab';
import SendingDomainsTable from './SendingDomainsTable';
import TrackingDomainsTable from './TrackingDomainsTable';
import SetupForSending from './SetupForSending';
import DomainStatusSection from './DomainStatusSection';
import DeleteDomainSection from './DeleteDomainSection';
import LinkTrackingDomainSection from './LinkTrackingDomainSection';
import SetupBounceDomainSection from './SetupBounceDomainSection';
import VerifyEmailSection from './VerifyEmailSection';
import SendingAndBounceDomainSection from './SendingAndBounceDomainSection';
import TrackingDomainStatusCell from './TrackingDomainStatusCell';
import TrackingDnsSection from './TrackingDnsSection';

export default {
  CreateForm,
  Container,
  SendingDomainsTab,
  TrackingDomainsTab,
  SendingDomainsTable,
  TrackingDomainsTable,
  SetupForSending,
  SetupBounceDomainSection,
  SendingAndBounceDomainSection,
  DeleteDomainSection,
  DomainStatusSection,
  LinkTrackingDomainSection,
  VerifyEmailSection,
  TrackingDomainStatusCell,
  TrackingDnsSection
};
